import { createContext } from "react";

export const TicketPrinterContext = createContext(null);
